import { onMounted, ref } from 'vue';

export const useMounted = () => {
  const hasMounted = ref(false);
  onMounted(() => (hasMounted.value = true));

  return hasMounted;
};
